export default __webpack_public_path__ + "static/musique-728a5d3ddc6c50440e5846993c1fd53e.jpg";